import { gql } from '@apollo/client';
import { apolloClient } from '../../data-processing/graphql';

const deletePeakDay = require('./delete-peak-day.gql');

export function deletePeakDayMutation(id: number) {
  return apolloClient.mutate<any>({
    mutation: gql(deletePeakDay),
    variables: { id },
  });
}
